document.addEventListener('DOMContentLoaded', function () {

  // Пазим стойностите тук - оцелява дори когато DOM-ът на формата
  // бъде заменен (при смяна на вариант/размер).
  window.woccoState = window.woccoState || {
    name: '',
    number: '',
    team: '',
    message: '',
    bg: 'tunnel'
  };

  let isInitialized = false;

  function initWoccoPreview() {

    const fields = {
      name: document.querySelector('input[name="properties[Име]"]'),
      number: document.querySelector('input[name="properties[Номер]"]'),
      team: document.querySelector('input[name="properties[Отбор]"]'),
      message: document.querySelector('input[name="properties[Послание]"]')
    };

    // Ако формата все още не е в DOM-а (напр. продукт без персонализация), излизаме тихо
    if (!fields.name && !fields.number && !fields.team) return;

    // --- Възстановяваме запазените стойности в новите полета ---
    if (fields.name) fields.name.value = window.woccoState.name || '';
    if (fields.number) fields.number.value = window.woccoState.number || '';
    if (fields.team) fields.team.value = window.woccoState.team || '';
    if (fields.message) fields.message.value = window.woccoState.message || '';

    // --- Избор на фон ---
    const bgOptions = document.querySelectorAll('.wocco-bg-option');
    const bgHiddenInput = document.getElementById('woccoSelectedBg');
    const hasHoverSupport = window.matchMedia('(hover: hover)').matches;

    function selectBg(option, save) {
      bgOptions.forEach(function (o) {
        o.classList.remove('is-selected', 'is-zoomed');
      });
      option.classList.add('is-selected');

      const label = option.querySelector('.wocco-bg-label');
      if (bgHiddenInput && label) {
        bgHiddenInput.value = label.textContent.trim();
      }
      if (save !== false) {
        window.woccoState.bg = option.dataset.bg;
      }
    }

    // Възстановяваме избрания фон от запазеното състояние
    bgOptions.forEach(function (option) {
      if (option.dataset.bg === window.woccoState.bg) {
        selectBg(option, false);
      }

      option.addEventListener('click', function () {
        if (!hasHoverSupport && !option.classList.contains('is-zoomed')) {
          bgOptions.forEach(function (o) { o.classList.remove('is-zoomed'); });
          option.classList.add('is-zoomed');
          return;
        }
        selectBg(option);
      });
    });

    document.addEventListener('touchstart', function (e) {
      if (!hasHoverSupport && !e.target.closest('.wocco-bg-option')) {
        bgOptions.forEach(function (o) { o.classList.remove('is-zoomed'); });
      }
    }, { passive: true });

    const previewBox = document.getElementById('woccoLivePreview');
    const previewTeam = document.getElementById('woccoPreviewTeam');
    const previewName = document.getElementById('woccoPreviewName');
    const previewNumber = document.getElementById('woccoPreviewNumber');
    const previewMessage = document.getElementById('woccoPreviewMessage');
    const previewImg = document.getElementById('woccoPreviewImg');
    const fieldsContainer = document.querySelector('.custom-fields');

    let activeInput = null;

    if (!previewBox) return;

    if (previewBox.parentNode !== document.body) {
      document.body.appendChild(previewBox);
    }

    // --- Ограничение за номер: 0 - 99, без негативни ---
    function clampNumberField() {
      if (!fields.number) return;

      let val = fields.number.value;
      val = val.replace(/[^\d]/g, '');

      if (val.length > 2) {
        val = val.slice(0, 2);
      }

      if (val !== '') {
        let num = parseInt(val, 10);
        if (num > 99) num = 99;
        if (num < 0) num = 0;
        val = String(num);
      }

      fields.number.value = val;
      window.woccoState.number = val;
    }

    if (fields.number) {
      fields.number.addEventListener('keydown', function (e) {
        if (e.key === '-' || e.key === '+' || e.key === 'e' || e.key === 'E') {
          e.preventDefault();
        }
      });

      fields.number.addEventListener('input', function () {
        clampNumberField();
      });

      fields.number.addEventListener('blur', function () {
        clampNumberField();
      });
    }

    // --- Шаблони по отбор ---
    const CDN_BASE = 'https://cdn.shopify.com/s/files/1/1044/7254/3564/files/';
    const DEFAULT_TEMPLATE = 'primeren-dizain.webp';

    const TEAM_TEMPLATES = [
      { key: 'levski', keywords: ['левски', 'levski'], file: 'primeren-dizain-levski.webp' },
      { key: 'cska',   keywords: ['цска', 'cska'],     file: 'primeren-dizain-cska.webp' },
      { key: 'loko',   keywords: ['локомотив', 'lokomotiv'], file: 'primeren-dizain-loko.webp' },
      { key: 'botev',  keywords: ['ботев', 'botev'],   file: 'primeren-dizain-botev.webp' }
    ];

    function getTeamTemplate(teamValue) {
      const v = (teamValue || '').toLowerCase();
      for (const t of TEAM_TEMPLATES) {
        if (t.keywords.some(k => v.indexOf(k) !== -1)) {
          return t;
        }
      }
      return null;
    }

    function updateTemplateImage() {
      if (!previewImg) return;

      const teamValue = fields.team?.value.trim() || '';
      const matched = getTeamTemplate(teamValue);
      const file = matched ? matched.file : DEFAULT_TEMPLATE;
      const key = matched ? matched.key : 'default';

      previewBox.classList.remove('is-levski', 'is-cska', 'is-loko', 'is-botev', 'is-default');
      previewBox.classList.add('is-' + key);

      if (previewImg.getAttribute('data-current') === file) return;

      previewImg.classList.add('is-swapping');

      const newSrc = CDN_BASE + file;
      const tempImg = new Image();
      tempImg.onload = function () {
        previewImg.src = newSrc;
        previewImg.setAttribute('data-current', file);
        previewImg.classList.remove('is-swapping');
      };
      tempImg.onerror = function () {
        previewImg.classList.remove('is-swapping');
      };
      tempImg.src = newSrc;
    }

    function fitText(el, max, min) {
      if (!el) return;

      let size = max;
      el.style.fontSize = size + 'px';

      while (el.scrollWidth > el.clientWidth && size > min) {
        size--;
        el.style.fontSize = size + 'px';
      }
    }

    function updatePreview() {
      if (previewTeam) previewTeam.textContent = fields.team?.value.trim() || 'ИМЕ НА ОТБОР';
      if (previewName) previewName.textContent = fields.name?.value.trim() || 'ВАШЕ ИМЕ';
      if (previewNumber) previewNumber.textContent = fields.number?.value.trim() || '10';
      if (previewMessage) previewMessage.textContent = fields.message?.value.trim() || 'ВАШЕ ПОСЛАНИЕ';

      fitText(previewTeam, 13, 7);
      fitText(previewName, 13, 7);
      fitText(previewNumber, 54, 30);
      fitText(previewMessage, 11, 6);

      updateTemplateImage();
    }

    const MOBILE_BREAKPOINT = 749;

    function isMobile() {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function positionPreview() {
      if (!previewBox || !fieldsContainer) return;

      if (isMobile()) {
        previewBox.style.top = '';
        previewBox.style.left = '';
        return;
      }

      const rect = fieldsContainer.getBoundingClientRect();
      const popupWidth = previewBox.offsetWidth || 300;
      const popupHeight = previewBox.offsetHeight || 300;

      let left = rect.left + window.scrollX + (rect.width - popupWidth) / 2;
      let top = rect.top + window.scrollY - popupHeight - 12;

      const minTop = window.scrollY + 10;
      if (top < minTop) top = minTop;

      if (left + popupWidth > window.innerWidth - 10) {
        left = window.innerWidth - popupWidth - 10;
      }
      if (left < 10) {
        left = 10;
      }

      previewBox.style.top = top + 'px';
      previewBox.style.left = left + 'px';
    }

    function showPreview(input) {
      activeInput = input;
      updatePreview();
      previewBox.classList.add('is-active');
      requestAnimationFrame(positionPreview);
    }

    function hidePreviewIfClickedOutside(e) {
      const clickedInsideFields = e.target.closest('.custom-fields');
      const clickedInsidePreview = e.target.closest('#woccoLivePreview');

      if (!clickedInsideFields && !clickedInsidePreview) {
        previewBox.classList.remove('is-active');
        activeInput = null;
      }
    }

    Object.keys(fields).forEach(function (key) {
      const input = fields[key];
      if (!input) return;

      input.addEventListener('focus', function () {
        showPreview(input);
      });

      input.addEventListener('click', function () {
        showPreview(input);
      });

      input.addEventListener('input', function () {
        window.woccoState[key] = input.value;
        showPreview(input);
      });
    });

    document.addEventListener('click', hidePreviewIfClickedOutside);
    document.addEventListener('touchstart', hidePreviewIfClickedOutside, { passive: true });

    window.addEventListener('scroll', function () {
      if (activeInput && previewBox.classList.contains('is-active')) {
        positionPreview();
      }
    }, { passive: true });

    window.addEventListener('resize', function () {
      if (activeInput && previewBox.classList.contains('is-active')) {
        positionPreview();
      }
    });

    // Обновяваме визуализацията веднага с възстановените стойности
    updatePreview();
  }

  initWoccoPreview();
  isInitialized = true;

  // --- Следим за презаписване на DOM-а (напр. при смяна на размер/вариант) ---
  // Когато Shopify темата презареди buy-buttons секцията, полетата стават
  // нови DOM елементи и губят стойности + listeners. Тук ги възстановяваме.
  const observerTarget = document.querySelector('main') || document.body;

  const woccoObserver = new MutationObserver(function (mutations) {
    let shouldReinit = false;

    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          node.matches?.('.custom-fields, .wocco-bg-select, .wocco-preview-popup') ||
          node.querySelector?.('.custom-fields, .wocco-bg-select, .wocco-preview-popup')
        ) {
          shouldReinit = true;
          break;
        }
      }
      if (shouldReinit) break;
    }

    if (shouldReinit) {
      // малко забавяне, за да е сигурно че DOM-ът е финализиран
      setTimeout(initWoccoPreview, 30);
    }
  });

  woccoObserver.observe(observerTarget, { childList: true, subtree: true });

});